import axios from "axios"
import requesturl from "../requesturl"
import auth from "../auth";
import cookiemanager from "../managers/cookiemanager";

export default {

    async getUserRoles(userRoles) {
        const response = await axios.get(requesturl() + "/api/latest/UserRole",
            {headers: {Authorization: window.$cookies.get("token")}})
            .catch(error => {
                if (error.response && error.response.status === 401) {
                    auth.logout();
                    window.$router.push('login');
                }
            });

        cookiemanager.updateCookies(response.headers);

        if (response.status === 204) {
            userRoles(null);
        } else {
            userRoles(response.data);
        }
    },

    async getUserRolesForUser(userId, userRoles) {
        const response = await axios.get(requesturl() + "/api/latest/User/" + userId + '/UserRole',
            {headers: {Authorization: window.$cookies.get("token")}})
            .catch(error => {
                if (error.response && error.response.status === 401) {
                    auth.logout();
                    window.$router.push('login');
                }
            });

        cookiemanager.updateCookies(response.headers);

        if (response.status === 204) {
            userRoles(null);
        } else {
            userRoles(response.data);
        }
    },

    async postUserRole(userRole, response) {
        const headers = {
            'Authorization': window.$cookies.get("token"),
            'Content-Type': "application/json"
        };

        await axios({
            method: "post",
            url: requesturl() + "/api/latest/UserRole",
            headers: headers,
            data: JSON.stringify(userRole)
        }).then(res => {
            cookiemanager.updateCookies(res.headers);

            let responseObj = {
                error: false,
                status: res.status
            };

            response(responseObj);
        }).catch(error => {
            let responseObj = {
                error: true,
                status: error.response != null ? error.response.status : 503
            };

            if (error.response && error.response.status === 401) {
                auth.logout();
                window.$router.push('login');
            }

            response(responseObj);
        });
    },

    async deleteUserRole(userRole, response) {
        await axios.delete(requesturl() + "/api/latest/UserRole/" + userRole.userRoleId,
            {headers: {Authorization: window.$cookies.get("token")}})
            .then((res) => {
                cookiemanager.updateCookies(res.headers);
                let responseObj = {
                    error: false,
                    status: res.status
                };

                response(responseObj);
            }).catch(error => {
                let responseObj = {
                    error: true,
                    status: error.response != null ? error.response.status : 503
                };

                if (error.response && error.response.status === 401) {
                    auth.logout();
                    window.$router.push('login');
                }

                response(responseObj);
            });
    }
}


// WEBPACK FOOTER //
// ./src/interfaces/userroleinterface.js